import React, { FC } from 'react'

import { PublicNode } from '../../../__generated__/api'

import { SearchTreeItem } from './types'
import { autocompleteItemIconProvider, searchTreeItemIconProvider } from './utils'

type Props = {
  item?: SearchTreeItem<PublicNode>
  src?: string
}

export const PublicNodeIcon: FC<Props> = ({ item, src }) => {
  const icon = item ? searchTreeItemIconProvider(item) : autocompleteItemIconProvider(src)
  return (
    <img
      src={icon}
      aria-hidden="true"
      style={{
        width: '28px',
        height: '28px',
        filter:
          'invert(23%) sepia(85%) saturate(1811%) hue-rotate(130deg) brightness(100%) contrast(101%)',
        shapeRendering: 'crispEdges',
      }}
    />
  )
}
